import { render, staticRenderFns } from "./SurveyResponsesTable.vue?vue&type=template&id=87ac879a&"
import script from "./SurveyResponsesTable.vue?vue&type=script&lang=js&"
export * from "./SurveyResponsesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports